<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="formSubmitting"
  [isDisabled]="workForm.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="workForm">
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Résumé</mat-label>
            <input matInput placeholder="" type="text" required formControlName="summary" />
            <mat-error>
              <span *ngIf="f('summary').hasError('required')">Veuillez saisir un résumé</span>
            </mat-error>
            <mat-error>
              <span *ngIf="f('summary').hasError('maxlength')">Le résumé ne doit dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type" required placeholder="">
              <mat-option *ngFor="let type of propertyHelper.getWorkTypes()" [value]="type">
                {{ propertyHelper.getWorkTypeName(type) }}</mat-option>
            </mat-select>
            <mat-error>
              <span *ngIf="f('type').hasError('required')">Veuillez sélectionner un type</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Début</mat-label>
            <input *ngIf="isBrowserSupportsDateInput(); else dateStartPicker" matInput placeholder="" type="date"
              required formControlName="dateStart" />
            <ng-template #dateStartPicker>
              <input matInput [matDatepicker]="pickerStart" required formControlName="dateStart" />
              <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart></mat-datepicker>
            </ng-template>
            <mat-error>
              <span *ngIf="f('dateStart').hasError('required')">Veuillez saisir une date</span>
              <span *ngIf="f('dateStart').hasError('dateFuture')">Date future non autorisée</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Fin</mat-label>
            <input *ngIf="isBrowserSupportsDateInput(); else dateEndPicker" matInput placeholder="" type="date" required
              formControlName="dateEnd" />
            <ng-template #dateEndPicker>
              <input matInput [matDatepicker]="pickerEnd" required formControlName="dateEnd" />
              <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
              <mat-datepicker #pickerEnd></mat-datepicker>
            </ng-template>
            <mat-error>
              <span *ngIf="f('dateEnd').hasError('required')">Veuillez saisir une date</span>
              <span *ngIf="f('dateEnd').hasError('beforeDateStart')">La date de fin doit être après celle de
                début</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Description</mat-label>
            <input matInput placeholder="" formControlName="description" />
            <mat-error>
              <span *ngIf="f('description').hasError('maxlength')">La description ne doit pas dépasser 160
                caractères</span>
            </mat-error>
          </mat-form-field>
          <mat-slide-toggle class="col-md-6 mt-3 mb-4" formControlName="energyImpact"
            [checked]="this.f('energyImpact').value" color="primary">Impacte la consommation d'énergie
            ?</mat-slide-toggle>
          <mat-form-field class="col-md-6">
            <mat-label>Coût (€)</mat-label>
            <input matInput placeholder="" type="text" formControlName="cost" nullValue decimalValue />
            <mat-error>
              <span *ngIf="f('cost').hasError('pattern') || f('cost').hasError('min')">Le coût doit être un nombre
                positif"</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Entreprise</mat-label>
            <input matInput placeholder="" type="text" formControlName="company" />
            <mat-error>
              <span *ngIf="f('company').hasError('maxlength')">Le nom ne doit dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
        <p>Documents</p>
        <div class="form-group row">
          <ng-container *ngFor="let doc of documents">
            <app-doc-add-widget class="col-12 col-lg-6 col-xl-4" [prop]="data.prop" category="WORK"
              title="{{ 'enum.DocumentType.'+doc.type | translate }}" (docDeleted)="onExistingDocDeleted($event)"
              [withSelect]="true" [document]="doc"></app-doc-add-widget>
          </ng-container>
          <ng-container *ngFor="let count of newDocumentsCount">
            <app-doc-add-widget class="col-12 col-lg-6 col-xl-4" [prop]="data.prop" category="WORK" title="Nouveau"
              (docSelected)="onNewDocSelected($event)" (docDeleted)="onNewDocDeleted($event)"
              [withSelect]="true"></app-doc-add-widget>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</ng-template>